// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale from "../helper/scaling";

import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  padding-bottom: 65px;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1100px) {
    justify-content: space-between;

    width: calc(100% - 50px);
    padding: 0 25px ${scale(1100, 767, 65, 30, "vw")} 25px;
  }

  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 15px 23px;
    padding: 0;
    flex-wrap: wrap;
  }
`;
const Image = styled.div`
  width: 637px;
  height: 357px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 637, 400, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    padding-bottom: 55.6%;
    margin: 0 0 17px 0;
    height: 0;
    float: left;
  }
`;
const Items = styled.div`
  width: 403px;

  @media (max-width: 1100px) {
    width: 50px;
    flex-basis: 50px;
    flex-grow: 1;
  }
  @media (max-width: 700px) {
    width: 100%;
    flex-grow: 0;
    flex-basis: auto;
  }
`;

class SetCheckmarked extends Component {
  image = item => {
    if (item.images.intro) {
      return {
        backgroundImage: 'url("' + item.images.intro.url + '")'
      };
    }
    if (item.images.main) {
      return {
        backgroundImage: 'url("' + item.images.main.url + '")'
      };
    }
    return {};
  };
  render() {
    let first = this.props.set[0];
    let items = [];
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i]);
    }
    return (
      <Wrapper>
        <Image style={this.image(first)} />
        <Items>{items.map(item => <Checkmarked key={item.id} content={item} />)}</Items>
      </Wrapper>
    );
  }
}

export default SetCheckmarked;

const Item = styled.div`
  width: calc(100% - 80px);
  padding: 7px 0 7px 80px;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);

  position: relative;

  @media (max-width: 1100px) {
    padding: 7px 0 7px ${scale(1100, 767, 80, 60, "vw")};
    width: ${scale(1100, 767, 332, 256, "vw")};
    font-size: ${scale(1100, 767, 14, 12, "vw")};
    line-height: ${scale(1100, 767, 14 * 1.43, 12 * 1.6, "vw")};
  }
  @media (max-width: 700px) {
    width: calc(100% - 29px);
    padding: 0 0 0 29px;
    margin: 5px 0;

    font-size: 11px;
    line-height: 1.64;
  }
`;
const CheckmarkContainer = styled.div`
  width: 23px;
  height: 16px;

  position: absolute;
  left: 30px;
  top: 10px;

  svg {
    width: 100%;
    height: 100%;
    float: left;
  }

  @media (max-width: 1100px) {
    left: ${scale(1100, 767, 30, 20, "vw")};
  }
  @media (max-width: 700px) {
    height: 9px;
    width: 14px;

    top: 1px;
    left: 0;
  }
`;

class Checkmarked extends ArticleAbstract {
  render() {
    return (
      <Item {...this.link()}>
        {this.title()}
        <CheckmarkContainer>
          <Checkmark />
        </CheckmarkContainer>
      </Item>
    );
  }
}

class Checkmark extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="21"
        viewBox="0 0 27 21"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#7ED321"
          strokeWidth="6"
          d="M2 7.59L11.035 16 25 3"
        />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetCheckmarked.js